import { z } from 'zod';

// Fehlerformat der API (SPEC §7). Besitzer: geruest; api-kern darf ergänzen.
export const ERROR_CODES = [
  'VALIDATION_ERROR',
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'PHASE_CLOSED',
  'LOCKED',
  'NO_ACTIVE_CONTRACT',
  'VERSION_MISMATCH',
  'RULE_VIOLATION',
  'RATE_LIMITED',
  'NOT_CONFIGURED',
  'MODULE_UNAVAILABLE',
  'SIMULATED_FAILURE',
  'INTERNAL',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(ERROR_CODES),
    message: z.string(),
    details: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    requestId: z.string().optional(),
  }),
});

export type ApiErrorBody = z.infer<typeof apiErrorSchema>;

/** Antwort von GET /api/health. */
export const healthSchema = z.object({
  status: z.literal('ok'),
  app: z.string(),
  version: z.string(),
  db: z.object({
    mode: z.enum(['external', 'pglite']),
    schema: z.string(),
    pglite: z.enum(['memory', 'file']).optional(),
  }),
  authMode: z.enum(['supabase', 'local', 'demo']),
  clock: z.object({ today: z.string(), now: z.string(), fixed: z.boolean() }),
  modules: z.array(z.object({ key: z.string(), status: z.enum(['ok', 'error']) })),
});

export type Health = z.infer<typeof healthSchema>;
